import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { Component, useState, useEffect } from 'react';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import './HorizontalMenu.css';

var MenuItem = function MenuItem(_ref) {
  var text = _ref.text,
      isActive = _ref.isActive,
      isRetail = _ref.isRetail,
      href = _ref.href;

  if (isRetail) {
    return /*#__PURE__*/React.createElement("a", {
      href: href,
      className: "menu-item ".concat(isActive ? 'active' : '')
    }, text);
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: "menu-item ".concat(isActive ? 'active' : '')
    }, text);
  }
};

var LeftArrow = function LeftArrow(_ref2) {
  var size = _ref2.size;
  return /*#__PURE__*/React.createElement(FiChevronLeft, {
    size: size
  });
};

var RightArrow = function RightArrow(_ref3) {
  var size = _ref3.size;
  return /*#__PURE__*/React.createElement(FiChevronRight, {
    size: size
  });
};

var Menu = function Menu(list, activeItem, isRetail) {
  var getElementId = function getElementId(element) {
    var _element$value;

    return isRetail ? element === null || element === void 0 ? void 0 : element.href : element === null || element === void 0 ? void 0 : (_element$value = element.value) === null || _element$value === void 0 ? void 0 : _element$value.id;
  };

  return list.map(function (el) {
    var value = el.value,
        path = el.path;
    return /*#__PURE__*/React.createElement(MenuItem, {
      href: el === null || el === void 0 ? void 0 : el.href,
      isRetail: isRetail,
      onClick: function onClick() {
        var mobileRootContainer = document.getElementsByClassName("scrollToNavMenu")[0];

        var performScroll = function performScroll(element) {
          if (!element) return;
          element === null || element === void 0 ? void 0 : element.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
          });
          window.setTimeout(function () {
            window.scrollTo(0, window.pageYOffset - 100);
          }, 1200); // window.scrollTo(0,element.scrollTop)
        };

        performScroll(mobileRootContainer); // performScroll(desktopRootContainer)
      },
      text: isRetail ? el === null || el === void 0 ? void 0 : el.text : value === null || value === void 0 ? void 0 : value.text,
      key: getElementId(el),
      isActive: activeItem == getElementId(el)
    });
  });
};

var ArrowLeft = LeftArrow({
  size: '2em'
});
var ArrowRight = RightArrow({
  size: '2em'
});
export var HorizontalMenu = function HorizontalMenu(props) {
  var menuItems = Menu((props === null || props === void 0 ? void 0 : props.navLinks) || [], props === null || props === void 0 ? void 0 : props.activeItem, props === null || props === void 0 ? void 0 : props.isRetail);

  var _useState = useState(props === null || props === void 0 ? void 0 : props.activeItem),
      _useState2 = _slicedToArray(_useState, 2),
      activeItem = _useState2[0],
      setActiveItem = _useState2[1];

  var activeItemChangedCallback = props === null || props === void 0 ? void 0 : props.activeItemChangedCallback;
  var setCurrentPage = props === null || props === void 0 ? void 0 : props.setCurrentPage;
  useEffect(function () {}, [activeItem]);
  return /*#__PURE__*/React.createElement("div", {
    className: "horizontal-menuscroll justify-content-center",
    style: {
      paddingTop: props.paddingTop
    }
  }, /*#__PURE__*/React.createElement(ScrollMenu, {
    data: menuItems,
    scrollBy: 0,
    arrowLeft: ArrowLeft,
    arrowRight: ArrowRight,
    alignCenter: false,
    hideSingleArrow: false,
    scrollToSelected: true,
    selected: activeItem,
    disableTabindex: true,
    onSelect: function onSelect(item) {
      setActiveItem(item === null || item === void 0 ? void 0 : item.toLowerCase());
      activeItemChangedCallback(props === null || props === void 0 ? void 0 : props.navLinks, item, setCurrentPage);
    },
    useButtonRole: false
  }));
};